import { Main } from './pages/Main/Main';
import { Provider } from "mobx-react";
import { RootStore } from './store/RootStore';

(function (doc, win) {
  let docEI = doc.documentElement,
      resizeEvt = 'orientationchange' in window ? 'orientataionchange' : 'resize',
      recalc = function () {
          var clientWidth = docEI.clientWidth;
          if (!clientWidth) return;
          if (clientWidth < 1400) {
              clientWidth = 1400;
          }
          //100是字体大小，1536是开发时浏览器窗口的宽度，等比计算
          docEI.style.fontSize = 100 * (clientWidth / 1920) + 'px';
      }

  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);

function App() {
  return <Provider {...RootStore}>
      <Main></Main>
  </Provider>;
}

export default App;
